module.exports = __webpack_public_path__ + "media/images/shelf_preview_portrait-0fa5d271eea842cdec400e47075a942a.png";